import { render, staticRenderFns } from "./myAuthor.vue?vue&type=template&id=f0789b4c&scoped=true&"
import script from "./myAuthor.vue?vue&type=script&lang=js&"
export * from "./myAuthor.vue?vue&type=script&lang=js&"
import style0 from "./myAuthor.vue?vue&type=style&index=0&id=f0789b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0789b4c",
  null
  
)

export default component.exports